module.exports = __webpack_public_path__ + "3cfb503728052d0812b56c9d8ee9d621.svg";